import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Show toast message
 * @param {string} message - Message to show
 * @param {"success" | "error" | "info"} type - Type of toast
 * @param {number} duration - Duration in milliseconds (default 3000)
 */
export const showToast = (message, type = "info", duration = 3000) => {
  if (!message) return;

  switch (type) {
    case "success":
      toast.success(message, {
        position: "top-right",
        autoClose: duration,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-right",
        autoClose: duration,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      break;
    default:
      toast.info(message, {
        position: "top-right",
        autoClose: duration,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      break;
  }
};
